import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b3dc134"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "mobile-like-nav-header" };
const _hoisted_2 = { class: "action left" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "title" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "action right" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: "backbutton",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.goBack()))
            }, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _hoisted_6
    ]));
}
